import { Preferences } from "@capacitor/preferences";
import React, { useState } from "react";
import { Loading, loading } from "../Loading";

export default function useStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T | Loading>(loading());

  const setValue = async (value: T) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;

      setStoredValue(valueToStore);

      await Preferences.set({ key: key, value: JSON.stringify(valueToStore) });
    } catch (error) {
      console.log(error);
    }
  };

  React.useEffect(() => {
    Preferences.get({ key: key })
      .then(({ value }) => setStoredValue(value !== null ? JSON.parse(value) : initialValue))
      .catch((error) => {
        console.log(error);
        setStoredValue(initialValue);
      });
  }, [initialValue, key]);

  return [storedValue, setValue] as [T | Loading, (value: T) => Promise<void>];
}
